import { isNil } from 'lodash';
import { useState } from 'react';

const useScroll = () => {
  const [scrollY, setScrollY] = useState(null);

  const lockBodyScroll = (condition) => {
    const body = document.querySelector('body');
    const hasScroll = body && body.clientHeight > window.innerHeight;

    if (condition) {
      setScrollY(window.pageYOffset);
      body.style.top = `-${window.pageYOffset}px`;
      body.style.position = 'fixed';
      body.style.overflowY = hasScroll ? 'scroll' : '';
    } else {
      body.style.top = '';
      body.style.position = '';
      body.style.overflowY = 'auto';

      if (!isNil(scrollY)) {
        window.scrollTo({ left: 0, top: scrollY, behavior: 'instant' });
      }
    }
  };

  return {
    lockBodyScroll,
  };
};

export default useScroll;
